import script from "./MyVacanciesHeader.vue?vue&type=script&setup=true&lang=js"
export * from "./MyVacanciesHeader.vue?vue&type=script&setup=true&lang=js"

import "./MyVacanciesHeader.vue?vue&type=style&index=0&id=05b99306&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-05b99306"]])

export default __exports__